import React from 'react';
import { Building2, Home, ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';

const audiences = [
  {
    icon: Building2,
    title: 'Local Businesses',
    description: 'Scale your brand with high-retention short-form and long-form content that turns viewers into loyal customers.'
  },
  {
    icon: Home,
    title: 'Realtors & Agents',
    description: 'Stand out with cinematic property tours and agent spotlights that sell listings and build your personal brand.'
  }
];

const Audiences = () => {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="audiences" className="section-padding bg-[#050505] border-t border-white/5" data-testid="audiences-section">
      <div className="max-w-7xl mx-auto">
        <Reveal className="text-center max-w-3xl mx-auto mb-16">
          <p className="overline mb-5">Built For You</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
            Who we <span className="gold-gradient">make famous.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {audiences.map((audience, index) => {
            const Icon = audience.icon;
            return (
              <Reveal key={index} delay={index * 0.12}>
                <button
                  onClick={scrollToContact}
                  data-testid={`audience-card-${index}`}
                  className="group w-full text-left bg-[#0f0f0f] border border-white/5 rounded-2xl p-10 md:p-14 hover:border-[#d4af37]/40 transition-colors duration-500"
                >
                  <Icon size={44} className="text-[#d4af37] mb-8" strokeWidth={1.25} />
                  <h3 className="text-3xl md:text-4xl font-semibold text-white mb-4">{audience.title}</h3>
                  <p className="text-[#a0a0a0] leading-relaxed text-lg mb-8">{audience.description}</p>
                  <span className="inline-flex items-center gap-2 text-[#d4af37] font-medium uppercase tracking-[0.12em] text-sm">
                    Get Started
                    <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                  </span>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Audiences;
